define.alias("shared/components/shared/desktop-only-banner", "calendar/components/shared/desktop-only-banner");